import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import styles from "./confirmDialog.module.css";
import { DEMAND_ACTIONS } from "../../utils/constants/DemandConstant";
import { Submit } from "../../components/button/buttons";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FormErrorLabel, FormFieldLabel } from "../../components/label/Labels";
import Asterisk from "../../components/asterisk/Asterisk";


const getConfirmDialogMessage = (action) => {
    console.log("action",action)
   switch(action){
    case DEMAND_ACTIONS.INITIATE_FISIBILITY:
      return {
        title:"Confirm Feasibility Assessment Initiation",
        description:`This action will move the demand to the 'Feasibility Assessment' stage and notify the concerned Vodafone teams to begin evaluation.
        \nThis action is irreversible, and the demand cannot be moved back to the previous stage.
        \nAre you sure you want to proceed?`,
        submitBtn:"Initiate",
        cancelBtn:"Cancel",
        isCommentSectionVisible:false,
        isCommentRequired:false
      }
    case DEMAND_ACTIONS.INITIATE_FLOOR_PRICING:
      return {
        title:"Confirm Floor Pricing Initiation",
        description:`This action will move the demand to the 'Floor Pricing' stage and notify the concerned Vodafone  teams to begin baseline pricing preparation.
        \nThis action is irreversible, and the demand cannot be moved back to the previous stage.
        \nAre you sure you want to proceed?`,
        submitBtn:"Initiate",
        cancelBtn:"Cancel",
        isCommentSectionVisible:false,
        isCommentRequired:false
      }
    case DEMAND_ACTIONS.INITIATE_MARGIN:
      return {
        title:"Confirm Floor Price Submission",
        description:`This action will submit the floor price and share it directly with the account manager for quotation preparation and margin addition.
        \nOnce submitted, the floor price cannot be edited or withdrawn. This action is irreversible.
        \nAre you sure you want to proceed?`,
        submitBtn:"Submit",
        cancelBtn:"No",
        isCommentSectionVisible:true,
        isCommentRequired:false
      }
    case DEMAND_ACTIONS.GENERATE_QUOTATION:
      return {
        title:"Confirm Quotation Submission",
        description:`This action will submit the quotation and share it directly with the customer for review and approval.
        \nOnce submitted, the quotation cannot be edited or withdrawn. This action is irreversible.
        \nAre you sure you want to proceed?`,
        submitBtn:"Submit",
        cancelBtn:"Cancel",
        isCommentSectionVisible:true,
        isCommentRequired:false
      }
    case DEMAND_ACTIONS.COMPLETE_DRAFT_ORDERFORM:
      return {
        title:"Confirm Order Form Submission",
        description:`This action will submit the order form and share it directly with the customer for review.
        \nOnce submitted, the order form cannot be edited or withdrawn. This action is irreversible.
        \nAre you sure you want to proceed?`,
        submitBtn:"Submit",
        cancelBtn:"Cancel",
        isCommentSectionVisible:true,
        isCommentRequired:false
      }
    case DEMAND_ACTIONS.SAVE_ORDERFORM:
      return {
        title:"Confirm Download",
        description:`This action will download the order form for signing. Once downloaded, the order form cannot be edited in the portal.
        \nPlease download and save the file, sign it, and upload the same signed order form in the designated section to proceed.
        \n\nAre you sure you want to continue?`,
        submitBtn:"Yes",
        cancelBtn:"No",
        isCommentSectionVisible:false,
        isCommentRequired:false
      }
    case DEMAND_ACTIONS.SUBMIT_SIGNED_ORDERFORM:
      return {
        title:"Confirm Order Form Submission",
        description:`Please confirm that you have signed the order form before proceeding.
        \nOnce submitted, the signed order form will be shared with the Vodafone team for further processing.
        \nThis action is irreversible and the document cannot be changed after submission.
        \nAre you sure you want to proceed?`,
        submitBtn:"Submit",
        cancelBtn:"Cancel",
        isCommentSectionVisible:false,
        isCommentRequired:false
      }
    case DEMAND_ACTIONS.INITIATE_LEGAL_CONTRACT:
      return {
        title:"Confirm Submission to VGEL Team",
        description:`Submitting this order form will share it with the VGEL team for further signing. This action is irreversible.
        \nDo you want to continue?`,
        submitBtn:"Submit",
        cancelBtn:"Cancel",
        isCommentSectionVisible:false,
        isCommentRequired:false
      }
    case DEMAND_ACTIONS.INITIATE_PROVISIONING:
      return {
        title:"Confirm Service Build Initiation",
        description:`This action will initiate the Service Build stage and notify the engineering team to begin service provisioning and implementation.
        \nOnce initiated, the Service Build process cannot be reversed.
        \nAre you sure you want to proceed?`,
        submitBtn:"Submit",
        cancelBtn:"Cancel",
        isCommentSectionVisible:false,
        isCommentRequired:false
      }
      case DEMAND_ACTIONS.UPLOAD_LEGAL_CONTRACT:
        return {
          title:"Confirm Signed Order Form sharing",
          description:`This action will upload the duly signed order form and share it with the customer for their records and confirmation.
          \nOnce uploaded, the document cannot be modified or replaced.
          \nAre you sure you want to proceed?`,
          submitBtn:"Share",
          cancelBtn:"Cancel",
          isCommentSectionVisible:false,
          isCommentRequired:false
        }
      case DEMAND_ACTIONS.COMPLETE_DEMAND:
        return {
          title:"Complete Demand",
          description:`Are you sure you want to complete demand?`,
          submitBtn:"Yes",
          cancelBtn:"No",
          isCommentSectionVisible:true,
          isCommentRequired:false
        }
    default:
      return {
        title:"Confirm Action",
        description:`Do you really want to Proceed?.`,
        submitBtn:"Submit",
        cancelBtn:"Cancel",
        isCommentSectionVisible:false,
        isCommentRequired:false
      }

  }
};

export function ConfirmDialog(action, options = {}) {
  const msgobj = getConfirmDialogMessage(action);

  const danger = false;
  const closeOnOutsideClick = false;
  const closeOnEscape = true;

  // Dynamic config (options overrides msgobj overrides defaults)
  const commentConfig = {
    label: "Comment if any",
    required: msgobj?.isCommentRequired ?? false,
    maxLength: 1000,
    requiredMessage:"Comment is required.",
    placeholder: "Enter comment here",
    isCommentSectionVisible:msgobj?.isCommentSectionVisible ?? false
  };

  const EXISTING_SELECTOR = '[data-confirm-dialog-container="true"]';
  const existing = document.querySelector(EXISTING_SELECTOR);
  if (existing && existing.parentNode) {
    try {
      existing.parentNode.removeChild(existing);
    } catch {}
  }

  const container = document.createElement("div");
  container.setAttribute("data-confirm-dialog-container", "true");
  document.body.appendChild(container);
  const root = createRoot(container);

  let settled = false;
  let resolveFn;
  const promise = new Promise((resolve) => {
    resolveFn = resolve;
  });

  const cleanup = () => {
    try {
      flushSync(() => {
        root.unmount();
      });
    } catch {
      try {
        root.unmount();
      } catch {}
    }
    if (container && container.parentNode) {
      container.parentNode.removeChild(container);
    }
  };

  const settle = (value) => {
    if (settled) return;
    settled = true;
    cleanup();
    resolveFn(value);
  };

  // Yup schema (required/optional dynamically)
  const validationSchema = Yup.object().shape({
    comment: commentConfig.required
      ? Yup.string()
          .trim()
          .required(commentConfig.requiredMessage)
          .max(
            commentConfig.maxLength,
            `Maximum ${commentConfig.maxLength} characters allowed.`
          )
      : Yup.string()
          .max(
            commentConfig.maxLength,
            `Maximum ${commentConfig.maxLength} characters allowed.`
          )
          .notRequired(),
  });

  const Modal = () => {
    useEffect(() => {
      if (!closeOnEscape) return;
      const onKey = (e) => {
        if (e.key === "Escape") settle({ confirmed: false, comment: "" });
      };
      document.addEventListener("keydown", onKey);
      return () => document.removeEventListener("keydown", onKey);
    }, [closeOnEscape]);

    const stopPropagation = (e) => e.stopPropagation();

    return (
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        onMouseDown={() => {
          if (closeOnOutsideClick) settle({ confirmed: false, comment: "" });
        }}
        className={styles.overlay}
      >
        <div onMouseDown={stopPropagation} className={styles.dialog}>
          <div className={styles.header}>
            <div
              id="confirm-dialog-title"
              className={styles.hedertxt}
              style={{ margin: 0 }}
            >
              {msgobj?.title}
            </div>
          </div>

          <div className={styles.description}>
            <div className={styles.bodytxt}>
              {msgobj?.description?.split("\n").map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </div>
          </div>

          {/*Formik form */}
          <Formik
            initialValues={{ comment: "" }}
            validationSchema={validationSchema}
            validateOnMount={true}
            onSubmit={(values) => {
              settle({ confirmed: true, comment: values.comment || "" });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              isValid,
              submitForm,
              isSubmitting,
              setFieldValue,
            }) => {
              const count = (values.comment || "").length;
              const showError = (touched.comment || isSubmitting) && !!errors.comment;

              return (
                <>
                  {commentConfig.isCommentSectionVisible && (<div className={styles.commentSection}>
                    <FormFieldLabel text={commentConfig.label}
                      style={styles.commentBoxTitle} />
                    {commentConfig.required ? (
                      <Asterisk />
                    ) : null}

                    <textarea
                      name="comment"
                      className={`${styles.commentBox} ${showError ? styles.commentBoxError : ""
                        }`}
                      placeholder={commentConfig.placeholder}
                      value={values.comment}
                      maxLength={commentConfig.maxLength}
                      rows={3}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        //hard clamp (extra safety)
                        const next = (e.target.value || "").slice(0, commentConfig.maxLength);
                        setFieldValue("comment", next);
                      }}
                    />

                    {/* Counter + validation message */}
                    <div style={{display:"flex", justifyContent: showError?"space-between":"flex-end",marginBottom:"8px"}}>
                    {showError ? <FormErrorLabel text={errors.comment} /> : null}
                    {<label >{count}/{commentConfig.maxLength}</label>}
                </div>


                    {/* <div className={styles.commentMeta}>
                      <span className={styles.counter}>
                        {count}/{commentConfig.maxLength}
                      </span>

                      {showError && (
                        <span className={styles.validationMsgErr}>{errors.comment}</span>
                      )}
                    </div> */}
                  </div>
                  )}

                  <div className={styles.footer}>
                    <button
                      type="button"
                      onMouseDown={() => settle({ confirmed: false, comment: "" })}
                      className={styles.cancelBtn}
                      disabled={isSubmitting}
                    >
                      {msgobj?.cancelBtn}
                    </button>

                    <Submit
                      onClick={submitForm}
                      style={styles.headlesend}
                      loaderstyle={styles.loaderstyle}
                      isSubmitting={isSubmitting}
                      title={msgobj?.submitBtn}
                      // if your Submit supports disabled, keep this:
                      disabled={!isValid || isSubmitting}
                    />
                  </div>
                </>
              );
            }}
          </Formik>
        </div>
      </div>
    );
  };

  root.render(<Modal />);
  return promise;
}
